import { jsx as _jsx } from "react/jsx-runtime";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { Suspense } from "react";
import { useShouldShowMobileAppBanner } from "@faire/retailer/components/App/useShouldShowMobileAppBanner";
import { LazyMobileAppSnackbar } from "@faire/retailer/components/MobileAppSnackbar";
export var MobileAppSnackbarWrapper = function() {
    var isMobile = useViewport().isMobile;
    var shouldShowMobileAppBanner = useShouldShowMobileAppBanner();
    if (!isMobile || !shouldShowMobileAppBanner) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyMobileAppSnackbar, {})
    });
};
